import * as _ from 'lodash'
import { useEffect, useState } from 'react'
import * as React from 'react'

import PubSub from '@paytrace/pt-skel/Event/PubSub'
import { BatchTransactionOpResult } from '../types'
import Event from '../Event'
import { pastTenseEx } from '../Helper/BatchFeedback'
import { viewReceipt } from '../Helper/LegacyURLs'

interface Props {
  action: string
  className?: string
  merchantId: number
  include_surcharge?: boolean
}

export function BatchTransactionFeedback (props: Props): React.ReactElement {
  const self = Symbol('BatchTransactionFeedback')
  const [message, setMessage] = useState<React.ReactElement[]>([])

  useEffect(() => {
    PubSub.sub(
      self, Event.BATCH_TRANSACTION_FEEDBACK,
      (json: {
        response: BatchTransactionOpResult[],
        records: { [key: string]: { preamble?: string, requested_amount: number } }
      }) => {
        const maybeAddSurchargeMessage = (row: BatchTransactionOpResult): string => {
          const newTransactionId = _.get(row, 'data.transaction_id')
          const surcharge_amount = _.get(row, 'data.surcharge_amount')
          const approved_amount = _.get(row, 'data.approved_amount')
          const newTransactionIdMsg = newTransactionId ? ` (${props.action} id: ${newTransactionId})` : ''

          if (props.action !== 'transaction') {
            return ''
          }

          if (!props.include_surcharge || surcharge_amount == null || approved_amount == null) return ` ${newTransactionIdMsg}`

          const surchargeFormatted = Number(surcharge_amount).toFixed(2)
          const approvedFormatted = Number(approved_amount).toFixed(2)

          return `Surcharge Added: $${surchargeFormatted}, Total $${approvedFormatted} ${newTransactionIdMsg}`
        }

        const buildDisplayMessage = (row: BatchTransactionOpResult) => {
          const messageSegments = []
          const record = json.records[row.transaction_id]
          const preamble = record.preamble ? record.preamble : `Transaction ID ${row.transaction_id}`
          // For some things, like refund, a new row is created
          const subsequentTransactionId = _.get(row, 'data.transaction_id')
          messageSegments.push(preamble)
          messageSegments.push(`for $${record.requested_amount.toFixed(2)}`)
          messageSegments.push(`has been ${pastTenseEx(props.action)}`)
          if (props.action === 'refund') {
            messageSegments.push(`(${props.action} id: ${subsequentTransactionId})`)
          }
          return `${messageSegments.join(' ')}. ${maybeAddSurchargeMessage(row)}`
        }

        const msgElements = json.response
          .filter((row) => !!json.records[row.transaction_id])
          .map((row: BatchTransactionOpResult, index: number) => {
            const subsequentTransactionId = _.get(row, 'data.transaction_id')
            const receiptTransactionId = subsequentTransactionId ? String(subsequentTransactionId) : String(row.transaction_id)
            return (
              <div key={index}>
                {buildDisplayMessage(row)}{' '}
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault()
                    viewReceipt(String(props.merchantId), receiptTransactionId)
                  }}
                >
                  View Receipt
                </a>
                <br />
              </div>
            )
          }).filter(Boolean)
        setMessage(msgElements)
      })

    return () => {
      PubSub.unsub(self)
    }
  }, [self, props.action, props.merchantId])

  const classes = 'center success ' + (props.className || '')

  return message.length <= 0
    ? <React.Fragment />
    : <div className={classes}>{message}</div>
}
